import { ProductionTimeDTO } from '@/api/dto/ProductionTimeDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class ProductionTimeCRUD extends CrudEndpoint<ProductionTimeDTO> {
  constructor() {
    super('productiontime');
  }
}
